import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toNum } from '../lib/format';

export const RupeeInput = ({ id, label, value, onChange, hint, placeholder }) => {
  const [focused, setFocused] = React.useState(false);
  const display = focused || value === '' || value === null || value === undefined
    ? value
    : toNum(value).toLocaleString('en-IN');

  return (
    <div>
      {label && <Label htmlFor={id}>{label}</Label>}
      <div className="relative mt-1">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-indigo/60 text-sm font-medium">₹</span>
        <Input
          id={id}
          type="text"
          inputMode="numeric"
          value={display ?? ''}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => {
            const raw = e.target.value.replace(/[^0-9]/g, '');
            onChange(raw === '' ? '' : parseInt(raw, 10));
          }}
          className="pl-7 h-11"
          placeholder={placeholder || '0'}
        />
      </div>
      {hint && <div className="text-[11px] text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
};

export const NumberInput = ({ id, label, value, onChange, hint, placeholder, suffix }) => (
  <div>
    {label && <Label htmlFor={id}>{label}</Label>}
    <div className="relative mt-1">
      <Input
        id={id}
        type="text"
        inputMode="numeric"
        value={value ?? ''}
        onChange={(e) => {
          const raw = e.target.value.replace(/[^0-9]/g, '');
          onChange(raw === '' ? '' : parseInt(raw, 10));
        }}
        className={`h-11 ${suffix ? 'pr-14' : ''}`}
        placeholder={placeholder}
      />
      {suffix && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-indigo/60 text-xs font-medium">{suffix}</span>}
    </div>
    {hint && <div className="text-[11px] text-muted-foreground mt-1">{hint}</div>}
  </div>
);

export const RadioCards = ({ options, value, onChange, columns = 3 }) => {
  const cols = { 2: 'grid-cols-1 sm:grid-cols-2', 3: 'grid-cols-1 sm:grid-cols-3', 4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4' }[columns];
  return (
    <div className={`grid ${cols} gap-3`}>
      {options.map((opt) => (
        <div
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`radio-card ${value === opt.value ? 'selected' : ''}`}
        >
          <div className="text-sm font-semibold text-brand-indigo">{opt.label}</div>
          {opt.sub && <div className="text-[11px] text-muted-foreground mt-1">{opt.sub}</div>}
        </div>
      ))}
    </div>
  );
};
